import { Injectable } from '@angular/core';
import { BaseMockApi } from 'app/mock-api/base.api';
import { finance as financeData } from 'app/mock-api/dashboards/finance/finance.data';
import { cloneDeep } from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class FinanceMockApi extends BaseMockApi {
  private _finance: any = financeData;

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Register Mock API handlers
   */
  registerHandlers(): void {
    // -----------------------------------------------------------------------------------------------------
    // @ Sales - GET
    // -----------------------------------------------------------------------------------------------------
    this.fuseMockApiService.onGet('api/dashboards/finance').reply(() => [200, cloneDeep(this._finance)]);
  }
}
